/*
 * SCROLLTO
 */

(function($) { //pgrzech
	$.fn.scrollTo = function(target, speed, offsetTop) {
		speed = speed ? speed : 300;
		offsetTop = offsetTop ? offsetTop : 0;
		var dfd = jQuery.Deferred();

		var offset = (target instanceof jQuery) ? target.offset().top : $(target).offset().top;

		if (offset) {
			$("html, body").animate({
				scrollTop: offset + offsetTop
			}, speed, function() {
				dfd.resolve();
			});
		}

		return dfd.promise();

	};
	$.scrollTo = $(window).scrollTo;
}(jQuery));